<template>
  <div class="container mortgage-calculator" :id="calculatorName">

    <div class="row justify-content-center calculator-body">
      <div class="col-md-10 col-xl-8 mb-3">
        <div class="progress-container">
                    <div class="progress-bar-bg">
                        <div class="progress-bar-fill" :style="{ width: ((currentStep - 1) / (totalSteps - 1)) * 100 + '%' }"></div>
                    </div>
                </div>

                <div class="step-nav-buttons mt-4 text-center">
                    <button
                        type="button"
                        class="btn previous-step"
                        @click="prevStep"
                        v-if="currentStep != 1"
                    >
                        Back
                    </button>
                </div>


                <div class="calculator-container">

                    <div class="mb-5" @keyup="resetCalculation" @change="resetCalculation">

                        <div v-if="currentStep === 1">
                            <InputElement
                                
                                fieldText="How much do you want to borrow?"
                            >
                                <InputTypeNumber currencyPlaceholder placeholder="e.g. 230000" v-model="borrowValue"/>
                            </InputElement>
                        </div>

                        <div v-if="currentStep === 2">
                            <InputElement
                                
                                fieldText="Interest Rate"
                            >
                                <InputTypeNumber placeholder="%" v-model="interestRate"/>
                            </InputElement>
                        </div>

                        <div v-if="currentStep === 3">
                            <InputElement
                                fieldText="How many years would you like the mortgage over?"
                                class="pt-4"
                            >
                                <VueSlider
                                    ref="slider"
                                    v-model="years"
                                    v-bind="sliderOptions"
                                    class="mt-4 mt-md-0"
                                    @keyup="resetCalculation" @change="resetCalculation"
                                >
                                    <template #tooltip>
                                        <div style="min-width: 6rem; font-size: small;" v-if="years === null ">Set mortgage duration</div>
                                        <div v-if="years >= 5">{{ years }}</div>                                        
                                    </template>                                 
                                </VueSlider>
                            </InputElement>  
                        </div>

                        <div class="row mb-5" v-if="currentStep === 4">
                            <div class="col-12 booleanLabel">What mortgage type are you looking for?</div>
                            <div class="col-12 row calc-right-buttons-wrapper">
                                <MultiplyChoiceButton
                                    buttonText="Interest Only"
                                >
                                <input type="radio" v-model="repaymentType" value="interest-only">
                                </MultiplyChoiceButton>
                                <MultiplyChoiceButton
                                    buttonText="Repayment"
                                >
                                <input type="radio" v-model="repaymentType" value="repayment">
                                </MultiplyChoiceButton>
                            </div>
                        </div>

                        <div class="row mb-5" v-if="currentStep === 5">
                            <div class="col-12 booleanLabel">Why are you using the calculator today?</div>
                            <div class="col-12 row calc-right-buttons-wrapper">
                                <MultiplyChoiceButton
                                    buttonText="I’m ready to get a mortgage"
                                >
                                <input type="radio" v-model="calcReason1" value="I’m ready to get a mortgage">
                                </MultiplyChoiceButton>
                                <MultiplyChoiceButton
                                    buttonText="I’m curious to know what I can borrow"
                                >
                                <input type="radio" v-model="calcReason1" value="I’m curious to know what I can borrow">
                                </MultiplyChoiceButton>
                                <MultiplyChoiceButton
                                    buttonText="I want to understand what I can afford before I search for a home"
                                >
                                <input type="radio" v-model="calcReason1" value="I want to understand what I can afford before I search for a home">
                                </MultiplyChoiceButton>
                            </div>
                        </div>

                        <div class="row mb-5" v-if="currentStep === 6">
                            <div class="col-12 booleanLabel">When are you hoping to move?</div>
                            <div class="col-12 row calc-right-buttons-wrapper">
                            <MultiplyChoiceButton
                                buttonText="As soon as possible"
                            >
                                <input type="radio" v-model="calcReason2" value="As soon as possible">
                            </MultiplyChoiceButton>
                            <MultiplyChoiceButton
                                buttonText="In the next 3 months"
                            >
                                <input type="radio" v-model="calcReason2" value="In the next 3 months">
                            </MultiplyChoiceButton>
                            <MultiplyChoiceButton
                                buttonText="6-12 months from now"
                            >
                                <input type="radio" v-model="calcReason2" value="6-12 months from now">
                            </MultiplyChoiceButton>
                            <MultiplyChoiceButton
                                buttonText="12+ months from now"
                            >
                                <input type="radio" v-model="calcReason2" value="12+ months from now">
                            </MultiplyChoiceButton>
                            </div>
                        </div>

                        <div class="step-nav-buttons mt-4 text-center">
                        <button
                        type="button"
                        class="btn next-step"
                        @click="nextStep"
                        v-if="currentStep != totalSteps - 1 && currentStep != 7"
                        :disabled="!isStepValid"
                        >
                        Continue
                        </button>

                        <button
                        type="button"
                        class="btn calculate"
                        v-if="currentStep === totalSteps - 1"
                        @click="calculate"
                        :disabled="!isStepValid"
                        >
                        Calculate
                        </button>
                    </div>                       
                        
                    </div>

                    <div v-if="currentStep === 7" ref="resultsContainer">

                        <ResultsContainer class="mt-5 mb-5 calc-results-box">
                        <div class="mb-3 results-title">Thank you for your details. With the information provided, your monthly repayment could be:</div>
                        <span class="fcs-price">£{{ monthlyRepayment.toFixed(2) }}</span>
                        </ResultsContainer>

                        <SubmissionForm :calculatorName="calculatorName" :calculatorData="collateMessageBody"/>

                    </div>                      

                  </div>
      </div>
    </div>

  </div>
</template>

<script>
import InputElement from '@/components/utilities/inputElement.vue'
import InputTypeNumber from '@/components/utilities/inputTypeNumber.vue'
import MultiplyChoiceButton from '@/components/utilities/multiplyChoiceButton.vue'
import ResultsContainer from '@/components/utilities/resultsContainer.vue'
import SubmissionForm from '@/components/utilities/submissionForm.vue'

import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/antd.css'

import axios from "axios"

export default {
  components: {
    InputElement,
		InputTypeNumber,
    MultiplyChoiceButton,
		ResultsContainer,
		SubmissionForm,
    VueSlider	
  },
  data() {
    return {
      currentStep: 1,
      totalSteps: 7,
      calculatorName: 'repayment-calculator',
      calcCompleted: false,
      borrowValue: 0,
      interestRate: 0,
      years: null,
      repaymentType: '',
      monthlyRepayment: 0,
      sliderOptions: {
        min: 5,
        max: 40
      },
      calculatorReasonTitle: null,
      calculatorReasonResults: null,
      calcReason1: "",
      calcReason2: "",
      listName: "",
      emailAddress: "",
      consent: "",
      submissionReason: {
        submitted: false,
        is_valid: false,
        confirmation_message: ''
      },
      submissionList: {
        submitted: false,
        is_valid: false,
        confirmation_message: ''
      },
      formErrors: [],
      gfid: 6, //Please check the Gravity Form for corresponding form id (staging and live may vary!)
      gfidlist: 9 //Please check the Gravity Form for corresponding form id (staging and live may vary!)
    }
  },
  methods: {
    calculate() {
      if (this.currentStep < this.totalSteps) {
          this.currentStep++;
      }
      this.monthlyRepayment = this.calculateMonthlyRepayment
      this.calcCompleted = true;
      this.calculatorReasonTitle = this.removeHyphensToUpperCase(this.calculatorName);
      this.calculatorReasonResults =
          `
            Why are you using the calculator today: ${this.calcReason1}
            When will you be ready to move forward: ${this.calcReason2}
            `;
      this.calculatorListName = this.listName;
      this.calculatorEmailAddress = this.emailAddress;
      this.calculatorConsent = this.consent;
      this.$nextTick(() => {
        const resultsContainer = this.$refs.resultsContainer;

        if (resultsContainer) {
          // Get the bounding rectangle of the element
          const rect = resultsContainer.getBoundingClientRect();

          // Calculate the target scroll position
          const targetScrollPosition = window.scrollY + rect.top - 200;

          // Scroll to the target position
          window.scrollTo({
            top: targetScrollPosition,
            behavior: 'smooth'
          });
        } else {
          console.error('resultsContainer is undefined');
        }
      });
      var newReasonSubmission = new FormData();
      var newListSubmission = new FormData();

      newReasonSubmission.append("form_id", this.gfid); //Please check the Gravity Form form id (staging and live may vary!)
      newReasonSubmission.append("input_1", this.calculatorReasonTitle);
      newReasonSubmission.append("input_3", this.calculatorReasonResults);

      newListSubmission.append("form_id", this.gfidlist); //Please check the Gravity Form form id (staging and live may vary!)
      newListSubmission.append("input_1", this.calculatorListName);
      newListSubmission.append("input_3", this.calculatorEmailAddress);
      newListSubmission.append("input_4.1", this.calculatorConsent ? 1 : 0);

      this.postReasonSubmission(newReasonSubmission);
      this.postListSubmission(newListSubmission);
    },
    async postReasonSubmission(submissionReasonData) {
      try {
        const response = axios.post('/wp-json/gf/v2/forms/8/submissions', submissionReasonData, {
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        });
        const submissionReason = response;
        
        this.submissionReason.is_valid = submissionReason.is_valid;
        this.submissionReason.confirmation_message = submissionReason.confirmation_message;
        this.submissionReason.validation_messages = submissionReason.validation_messages;

      } catch(error) {
        console.log(error)
      }
    },
    async postListSubmission(submissionListData) {
      try {
        const response = axios.post('/wp-json/gf/v2/forms/9/submissions', submissionListData, {
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        });
        const submissionList = response;
        
        this.submissionList.is_valid = submissionList.is_valid;
        this.submissionList.confirmation_message = submissionList.confirmation_message;
        this.submissionList.validation_messages = submissionList.validation_messages;

      } catch(error) {
        console.log(error)
      }
    },
    formatNumberOutput(number) {
      const newNumber = (new Intl.NumberFormat('en-GB').format(number))
      if (newNumber === 'NaN') {
        return 0
      }
      return newNumber
    },
    removeHyphensToUpperCase(str) {
      return str.replace(/(-|^)([^-]?)/g, function (_, prep, letter) {
        return (prep && ' ') + letter.toUpperCase();
      });
    },
    resetCalculation() {
      this.calcCompleted = false;
    },
    nextStep() {
      if (this.currentStep < this.totalSteps) {
          this.currentStep++;
      }
    },
    prevStep() {
      if (this.currentStep === 7) {
          this.currentStep = 6;
      } else if (this.currentStep < this.totalSteps) {
          this.currentStep--;
      }
    },  
  },
  computed: {
    /**
     * Calculate the value of the monthly repayment
     * @return {Number}
     */
    isStepValid() {
            if (this.currentStep === 1) {
                return this.borrowValue != null;
            }
            if (this.currentStep === 2) {
                return this.interestRate != null;
            }
            if (this.currentStep === 3) {
                return this.years != null;
            }
            if (this.currentStep === 4) {
                return this.repaymentType === 'interest-only' || this.repaymentType === 'repayment';
            }
            if (this.currentStep === 5) {
                return this.calcReason1 != null;
            }
            if (this.currentStep === 6) {
                return this.calcReason2 != null;
            }
            return true;
        },
    calculateMonthlyRepayment() {
      let t = parseFloat(this.interestRate) / 100 / 12
      return parseFloat(this.borrowValue * t) / parseFloat(1 - Math.pow(1 + t, -(12 * this.years)))
    },
    collateMessageBody() {
      const calculatorData =
          {
            calculatorTitle: this.removeHyphensToUpperCase(this.calculatorName),
            calculatorResults:
                `
                    How much do you want to borrow? £${this.borrowValue}
                    Interest Rate: ${this.interestRate}%
                    How long do you want to borrow the money for? ${this.years}
                    What mortgage type are you looking for? ${this.repaymentType}
                    Result £${this.monthlyRepayment.toFixed(2)}
                    Why are you using the calculator today: ${this.calcReason1}
          When will you be ready to move forward: ${this.calcReason2}
                `
          }
      return calculatorData;
    }
  }
}
</script>

<style lang="scss">
@import './styles/calcs.scss';
@import './styles/slider.scss';
</style>